document.addEventListener('click', function (e) {

  // VARIANT DROPDOWN
  const trigger = e.target.closest('.custom-variant-trigger');

  if (trigger) {

    const wrapper = trigger.closest('.custom-variant-picker');

    document.querySelectorAll('.custom-variant-picker.active').forEach((item) => {

      if (item !== wrapper) {
        item.classList.remove('active');
      }

    });

    wrapper.classList.toggle('active');

    return;
  }

  // VARIANT SELECT
  const option = e.target.closest('.custom-variant-option');

  if (option) {

    const wrapper = option.closest('.custom-variant-picker');
    const productBox = option.closest('.our-collection-pro-box');

    const variantId = option.dataset.variantId;
    const variantPrice = option.dataset.price;
    const variantTitle = option.dataset.title;

    // LABEL UPDATE
    const label = wrapper.querySelector('.variant-label');

    if (label) {
      label.textContent = variantTitle;
    }

    // ACTIVE STATE
    wrapper.querySelectorAll('.custom-variant-option.active').forEach((item) => {
      item.classList.remove('active');
    });

    option.classList.add('active');

    // PRICE UPDATE
    const price = productBox.querySelector('.our-collection-price');

    if (price) {
      price.textContent = variantPrice;
    }

    // VARIANT INPUT UPDATE
    const variantInput = productBox.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (variantInput) {

      variantInput.value = variantId;

      requestAnimationFrame(() => {
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      });

    }

    wrapper.classList.remove('active');

    return;
  }

  // AJAX PAGINATION
  const link = e.target.closest('[id^="pagination-"] a');

  if (link) {

    e.preventDefault();

    const pagination = link.closest('[id^="pagination-"]');
    const sectionId = pagination.id.replace('pagination-', '');

    const grid = document.querySelector(`#product-grid-${sectionId}`);

    if (!grid || !pagination) return;

    const url = `${link.href}&section_id=${sectionId}`;

    grid.style.opacity = '0.4';

    fetch(url)
      .then((res) => res.text())
      .then((html) => {

        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector(`#product-grid-${sectionId}`);
        const newPagination = doc.querySelector(`#pagination-${sectionId}`);

        requestAnimationFrame(() => {

          if (newGrid) {
            grid.innerHTML = newGrid.innerHTML;
          }

          if (newPagination) {
            pagination.innerHTML = newPagination.innerHTML;
          }

          grid.style.opacity = '1';

          window.history.pushState({}, '', link.href);

          window.scrollTo({
            top: grid.getBoundingClientRect().top + window.scrollY - 100,
            behavior: 'smooth',
          });

        });

      })
      .catch((err) => console.log(err));

    return;
  }

  // OUTSIDE CLICK
  if (!e.target.closest('.custom-variant-picker')) {

    document.querySelectorAll('.custom-variant-picker.active').forEach((item) => {
      item.classList.remove('active');
    });

  }

}, { passive: true });